import { render, staticRenderFns } from "./case.vue?vue&type=template&id=2db53ac5&scoped=true"
import script from "./case.vue?vue&type=script&lang=js"
export * from "./case.vue?vue&type=script&lang=js"
import style0 from "./case.vue?vue&type=style&index=0&id=2db53ac5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db53ac5",
  null
  
)

export default component.exports